import { PlannedTwinIDNextStatus, PlannedTwinIDResult } from '@ynomia/core/dist/blueprint';

/**
 * `PlannedTwinIDResult` is typed as a discriminated union where `bandID` and
 * `nextPlannedStatus` only exist on the `'Active'` phase.
 * For now, the backend still returns these fields for `'Concluded'` results too, so we read
 * them defensively in one place rather than scattering `@ts-ignore` across every
 * call site.
 *
 * TODO: remove once the core types / backend are reconciled (i.e. decide what to
 * do with `phase === 'Concluded'` plans).
 */
type PlanResultFields = { bandID?: string, nextPlannedStatus?: PlannedTwinIDNextStatus };

export const getPlanResultFields = (
  result: PlannedTwinIDResult | undefined,
): PlanResultFields => (result || {}) as PlanResultFields;
